var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 4.16683V7.56681C14.6673 8.41348 14.3873 9.12682 13.8873 9.62016C13.394 10.1202 12.6807 10.4001 11.834 10.4001V11.6068C11.834 12.0601 11.3273 12.3335 10.954 12.0802L10.3073 11.6535C10.3673 11.4468 10.394 11.2201 10.394 10.9801V8.26685C10.394 6.90685 9.48732 6.00016 8.12732 6.00016H3.60065C3.50731 6.00016 3.42065 6.00684 3.33398 6.01351V4.16683C3.33398 2.46683 4.46732 1.3335 6.16732 1.3335H11.834C13.534 1.3335 14.6673 2.46683 14.6673 4.16683Z",
    stroke: "#F9FBFE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.394 8.26668V10.98C10.394 11.22 10.3673 11.4467 10.3073 11.6533C10.0607 12.6333 9.24732 13.2467 8.12732 13.2467H6.31399L4.30065 14.5867C4.00065 14.7933 3.60065 14.5733 3.60065 14.2133V13.2467C2.92065 13.2467 2.35399 13.02 1.96065 12.6267C1.56065 12.2267 1.33398 11.66 1.33398 10.98V8.26668C1.33398 7.00002 2.12065 6.12668 3.33398 6.01335C3.42065 6.00668 3.50731 6 3.60065 6H8.12732C9.48732 6 10.394 6.90668 10.394 8.26668Z",
    stroke: "#F9FBFE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.7a96bf4f04613b5b2adbfb3fd715fff3.svg";
export { ForwardRef as ReactComponent };